import styled from "@emotion/styled";
import { Button } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const FooterCampaign: FC = () => {

  const navigate = useNavigate();

  return (
    <ButtonWrapper>
      <Button size="large" type="primary" onClick={() => {
        navigate("/campaign/create-campaign");
      }} style={{ width: "100%" }}>
        เพิ่มแคมเปญใหม่
      </Button>
    </ButtonWrapper>
  );
};

export default FooterCampaign;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
